import { render, staticRenderFns } from "./mortgage-amschedule.vue?vue&type=template&id=4e310748"
import script from "./mortgage-amschedule.vue?vue&type=script&lang=ts"
export * from "./mortgage-amschedule.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports